<template>
  <div class="min-h-screen bg-background-light flex flex-col">


    <!-- ================= MAIN ================= -->
    <main class="flex-1 flex items-center justify-center p-4 sm:p-6">

      <div class="w-full max-w-md bg-white rounded-xl shadow-soft border border-primary/5 overflow-hidden">

        <!-- ================= HERO ================= -->
        <div class="relative h-36 sm:h-44 bg-primary/5 flex items-center justify-center">

          <div class="absolute inset-0 opacity-10 dot-pattern"></div>

          <div class="relative size-20 sm:size-24 bg-white rounded-full shadow-lg flex items-center justify-center">

            <div class="size-16 sm:size-20 bg-primary/10 rounded-full flex items-center justify-center">
              <span class="material-symbols-outlined text-primary text-4xl sm:text-5xl">
                mark_email_read
              </span>
            </div>

            <div class="absolute bottom-0 right-0 size-6 sm:size-7 bg-green-500 rounded-full border-4 border-white flex items-center justify-center">
              <span class="material-symbols-outlined text-white text-xs">
                check
              </span>
            </div>
          </div>
        </div>

        <!-- ================= CONTENT ================= -->
        <div class="p-5 sm:p-8 text-center">

          <h2 class="text-xl sm:text-2xl font-bold text-slate-900 mb-2 sm:mb-3">
            Verify Your Email
          </h2>

          <p class="text-slate-500 text-sm sm:text-base leading-relaxed mb-5 sm:mb-8">
            We've sent a verification link to your inbox. Please click the link
            to confirm your account and get started.
          </p>

          <!-- Actions -->
          <div class="space-y-2 sm:space-y-3">

            <button @click="resendEmail" class="primary-btn">
              <span class="material-symbols-outlined text-lg">send</span>
              Resend Email
            </button>

            <button @click="goBack" class="secondary-btn">
              Back to Login
            </button>
          </div>

          <!-- Hint -->
          <div class="mt-5 sm:mt-8 pt-4 sm:pt-6 border-t border-slate-100">
            <p class="text-slate-400 text-xs flex items-center justify-center gap-1">
              <span class="material-symbols-outlined text-sm">info</span>
              Didn't receive the email? Check your spam folder.
            </p>
          </div>
        </div>
      </div>
    </main>

    <!-- ================= FOOTER ================= -->
    <footer class="py-4 sm:py-6 text-center border-t border-slate-200">
      <p class="text-xs sm:text-sm text-slate-400">
        © 2024 SaaS Pro Inc. All rights reserved.
      </p>
    </footer>

  </div>
</template>

<script>
export default {
  methods: {
    resendEmail() {
      console.log('Resend verification email')
    },

    goBack() {
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped>
.shadow-soft {
  box-shadow:
    0 1px 3px rgba(0,0,0,0.06),
    0 10px 30px rgba(0,0,0,0.04);
}

.dot-pattern {
  background-image: radial-gradient(#197fe6 1px, transparent 1px);
  background-size: 18px 18px;
}

.primary-btn {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  background: #197fe6;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.primary-btn:hover {
  background: #166fd1;
}

.secondary-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  font-weight: 500;
  color: #475569;
  transition: all 0.2s ease;
}

.secondary-btn:hover {
  background: #f1f5f9;
}

/* ================= MOBILE POLISH ================= */

@media (max-width: 640px) {

  .primary-btn {
    height: 44px;
  }

}

</style>